import { IGenericBaryFormGroup } from './GenericBaryFormGroup';
import { FormGroup, ValidatorFn } from '@angular/forms';
import { FormGroupHelper } from './FormGroupHelper';
import { ThemeControls } from './builder/ThemeFormBuilder';
import { ThemeView } from '../theme-view.model';
import { patchObject } from '../../app/shared/util/object-util';

export class ThemeFormGroup extends FormGroupHelper implements IGenericBaryFormGroup<ThemeControls> {
  protected declare form: FormGroup;
  name = 'themeForm';
  updated = false;
  controls: ThemeControls;

  constructor(formName: string, controls: ThemeControls, validators?: ValidatorFn[]) {
    super();
    this.name = formName;
    this.form = this.newFormGroup(controls, validators);
    this.controls = controls;
  }

  getAngularForm(): FormGroup {
    return this.form;
  }

  updateForm(model: ThemeView): void {
    this.form.patchValue(model);
    this.updated = true;
  }

  value(): any {
    return this.form.value;
  }

  updateModel(model: ThemeView): void {
    patchObject(model, this.form.value);
  }
}
